var map = {
	"./ar-YE/core": [
		4517,
		517
	],
	"./bg-BG/core": [
		226,
		226
	],
	"./cs-CZ/core": [
		1804,
		804
	],
	"./da-DK/core": [
		1528,
		528
	],
	"./de-DE/core": [
		6291,
		291
	],
	"./en-GB/core": [
		1671,
		671
	],
	"./en-US/core": [
		7534
	],
	"./es-ES/core": [
		2653,
		653
	],
	"./fa-IR/core": [
		7347,
		347
	],
	"./fr-FR/core": [
		4744,
		744
	],
	"./hu-HU/core": [
		8887,
		887
	],
	"./id-ID/core": [
		6385,
		385
	],
	"./it-IT/core": [
		2647,
		647
	],
	"./ja-JP/core": [
		9033,
		33
	],
	"./ko-KR/core": [
		2256,
		256
	],
	"./nl-NL/core": [
		1915,
		915
	],
	"./pl-PL/core": [
		9376,
		376
	],
	"./pt-BR/core": [
		8049,
		49
	],
	"./ro-RO/core": [
		1350,
		350
	],
	"./ru-RU/core": [
		2521,
		902
	],
	"./sk-SK/core": [
		5623,
		623
	],
	"./sr-Cyrl-CS/core": [
		9016,
		16
	],
	"./sr-Latn-CS/core": [
		8038,
		38
	],
	"./sv-SE/core": [
		2478,
		478
	],
	"./tr-TR/core": [
		99,
		99
	],
	"./uk-UA/core": [
		2869,
		869
	],
	"./uz-UZ/core": [
		976,
		976
	],
	"./zh-CN/core": [
		9639,
		639
	],
	"./zh-TW/core": [
		6931,
		931
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5165;
module.exports = webpackAsyncContext;